export default __webpack_public_path__ + "static/media/player-icon.b1d5718b.svg";